


<ng-container *ngIf="fetching; else fetched">
  <div class="flex justify-content-center align-items-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-container>

<ng-template #fetched>

  <ng-container *ngIf="(sessionAttendance$ | async) as sa">

    <ng-container *ngIf="
      sa.attendances[ReservationState.CONFIRMED].length === 0 &&
      sa.attendances[ReservationState.APPROVED].length === 0
    ">
      <h5 *ngIf="!fetching">
        {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.no-participants' | translate }}
      </h5>
    </ng-container>

    <ng-container *ngFor="let ua of sa.attendances[ReservationState.CONFIRMED]; let i = index">
      <ng-container *ngTemplateOutlet="userAttendance, context: { FG: form.controls.confirmed, ua: ua, index: i }"></ng-container>
    </ng-container>

    <ng-container *ngFor="let ua of sa.attendances[ReservationState.APPROVED]; let i = index">
      <ng-container *ngTemplateOutlet="userAttendance, context: { FG: form.controls.approved, ua: ua, index: i }"></ng-container>
    </ng-container>

  </ng-container>

</ng-template>




<ng-template #userAttendance let-FG="FG" let-ua="ua" let-index="index">

  <app-user-session-attendance [FG]="FG.controls[index]" [ua]="ua" [sessionAttendance]="(sessionAttendance$ | async) ?? undefined"></app-user-session-attendance>

</ng-template>

